export default "__VITE_ASSET__8gr_smMC__"